// extracted by mini-css-extract-plugin
export var active = "_lc-2";
export var recordingDot = "_lc-1";
export var recordingIndicator = "_lc-0";